import React from 'react';

/////////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./dashboard_components/Main'),
  loading: Loading,
});
//////////////////////////////////////////////////////////

export default class Dashboard extends React.Component {
  render() {
    return (
      <div className="dashboard">
        <AsyncMain style={{ width: '80%' }} {...this.props} />
      </div>
    );
  }
}
